










import {
  Vue,
  Component,
  Prop
} from "vue-property-decorator";

@Component({
  components: {},
})
export default class CardConentVertical extends Vue {
    @Prop()
    public imgSrc!: String;
    @Prop()
    public value!: String;
    @Prop()
    public height?: Number;

   get style(){
       return {height: this.height + 'px'}
   }
}
